import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { setDynamicEnvironmentId } from "@gizmolab/depositos";
import App from "./App";
import "./index.css";

// Optional override. Left unset, the widget resolves its wallet environment
// from the depositOS API using the configured API key.
setDynamicEnvironmentId(import.meta.env.VITE_DYNAMIC_ENVIRONMENT_ID || undefined);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
